module.exports = __webpack_public_path__ + "img/cat house.084ce137.png";